import { __assign } from "tslib";
import { createFakeGetResponder, createFakePutResponder, createFakeDeleteResponder } from '../test-utils';
import { createHttpTestKit } from '../http/test-kit';
import { createTwitterApi, twitterRelativePath } from '.';
;
export var createTwitterApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createTwitterApi('', fakeHttp);
    var TestKit = {
        whenGetAccounts: function (validate) { return createFakeGetResponder(fakeHttp, twitterRelativePath + "/accounts?validate=" + !!validate); },
        whenUpdateAccount: function (dto) { return createFakePutResponder(fakeHttp, twitterRelativePath + "/accounts/" + (dto === '*' ? '' : dto.id))(dto); },
        whenDeleteAccount: function (id) { return createFakeDeleteResponder(fakeHttp, twitterRelativePath + "/accounts/" + id); }
    };
    return __assign(__assign({}, api), TestKit);
};
//# sourceMappingURL=testkit.js.map